import { redirect } from "react-router-dom";

import pathnames from "routes/pathnames";

import CONSTANTS from "constants/constant";

export const protectedRoutes = () => {
	const apiKey = localStorage.getItem(CONSTANTS.API_KEY) ?? sessionStorage.getItem(CONSTANTS.API_KEY);

	if (apiKey) return true;

	return redirect(pathnames.default);
};

export const publicRoutes = () => {
	const apiKey = localStorage.getItem(CONSTANTS.API_KEY) ?? sessionStorage.getItem(CONSTANTS.API_KEY);

	if (apiKey) return redirect(pathnames.solutions);

	return true;
};
